// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__Ve-SY","foodimg":"MealItem_foodimg__bVE-4","description":"MealItem_description__c0M4L","price":"MealItem_price__U2IAv"};